// extracted by mini-css-extract-plugin
export default {"table":"table_table__u7cWg","cellWithInput":"table_cellWithInput__mVqFT"};